import { render, staticRenderFns } from "./ServicePlaceBranchDialog.vue?vue&type=template&id=10a4c4eb&scoped=true&"
import script from "./ServicePlaceBranchDialog.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceBranchDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a4c4eb",
  null
  
)

export default component.exports